import { Observable } from "rxjs";

export default class MapDataStream {
    constructor(id) {
        this.id = id;

        this.subscribers = [];
        this.selectionSubscribers = [];
    }

    observe() {
        const observable = new Observable((subscriber) => {
            this.subscribers.push(subscriber);
            subscriber.next(this.mapElements);
        });
        return observable;
    }

    observeSelection() {
        const observable = new Observable((subscriber) => {
            this.selectionSubscribers.push(subscriber);
        });
        return observable;
    }

    toJSON() {
        return {
            id: this.id
        };
    }
}